module.exports = __webpack_public_path__ + "application/templates/default/inner/movements/inner/movements-details/movements-details.template.html";